// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__e5kap","ml10":"styles_ml10__3G-zF","primary":"styles_primary__3Yyar","tagBox":"styles_tagBox__1ByKQ"};